import React from 'react';
import styles from './outline.module.scss';
import cn from 'clsx';
import { Scene as SceneType } from '../sceneContainer/scene';

interface SceneProps {
    scene: SceneType;
}

const Outline = ({
    scene,
}: SceneProps) => {
    return (
        <div className={cn(styles.outlineContianer,
            {
                [styles.needEdits]: scene.needsEditing,
            }
        )}>
            <h2>Chapter {scene.chapter}, Scene {scene.sceneNumber}</h2>
            <p>{scene.scene}</p>
            <p>{scene.setting}</p>
            <p>{scene.sceneDetails}</p>
        </div>
    );
}

export default Outline;
